export const data = [
   {
      titulo: 'Foto',
      body: 'Almacenes La Riojana nació en 1911. El 18 de julio de 1936 grupos de izquierdas, tras el triunfo del golpe en Cádiz, fue saqueado. Afortunadamente no ardió como otras tiendas de la ciudad lo que le permitió reabrir pronto.'
   },
   {
      titulo: 'Foto',
      body: 'Entre estanterías vacías tras el ataque, dos carteles peculiares en La Riojana. Uno advierte de que todo se paga al contado y otro informa que no hay posibilidad de rebaja en los precios.'
   },
   {
      titulo: 'Foto',
      body: 'Los asaltantes arrasaron el interior de La Riojana. El establecimiento se mantuvo abierto hasta los años 80. Sus dueños fueron también propietarios de otros locales en la ciudad.'
   },
   {
      titulo: 'Foto',
      body: 'El edificio de Merchán, otro clásico de la ciudad, sí ardió tras el saqueo de sus dependencias ubicadas en la plaza del Palillero. Hubo que esperar a la reconstrucción de esta plaza para su reapertura.'
   },
   {
      titulo: 'Foto',
      body: 'Los comercios de la calle Columela fueron los más afectados por los incidentes tras el golpe militar. Uno de los locales que acabó ardiendo fue el del Café Lido.'
   },
   {
      titulo: 'Foto',
      body: 'Toda la zona entre Feduchy, Eduardo Dato y Palilleros sufrió tras la Guerra una profunda transformación tras los edificios destruidos al inicio de la contienda.'
   },
   {
      titulo: 'Foto',
      body: 'Varios voluntarios de las tropas golpistas posan ante uno de los edificios pastos de las llamas. La imagen no está datada.'
   },
   {
      titulo: 'Foto',
      body: 'Siniestra imagen del edificio donde antes de los sucesos del 18 de julio funcionaba la Maison du Blanc.'
   },
   {
      titulo: 'Foto',
      body: 'El colegio de la Viña cumple ahora 75 años desde su reconstrucción. El edificio fue destruido por las llamas tras sufrir un asalto por grupos anarquistas y de izquierda. El centro lasaliano de la  Mirandilla también sufrió daños.'
   },
   {
      titulo: 'Foto',
      body: 'Solves era uno de los establecimientos más clásicos de la zona del Palillero. También sufrió el robo de material de venta y la destrucción del edificio.'
   },
   {
      titulo: 'Foto',
      body: 'Otra perspectiva de la sede de Solves. Tras el conflicto armado, se levantó un nuevo edificio donde se instaló la tienda, una de las últimas clásicas en cerrar en el centro histórico hace apenas unos años.'
   },
   {
      titulo: 'Foto',
      body: 'Una imagen peculiar más allá de la tragedia. El hundimiento de una finca deja a la vista los restos de una cocina, incluida la campana y material de trabajo.'
   },
   {
      titulo: 'Foto',
      body: 'El fuego provocado acabó con el edificio donde estaba Casa Valiente, entre Catedral y Cobos. Sólo quedó en pie la fachada del inmueble.'
   },
   {
      titulo: 'Foto',
      body: 'La plaza de la Catedral, en la imagen las instalaciones de Casa Valiente en una esquina, fue una de las zonas más afectadas por los ataques de los grupos de izquierdas. Anarquistas y socialistas evitaron, sin embargo, la quema de otra finca en la misma plaza.'
   },
   {
      titulo: 'Foto',
      body: 'Las barajas, destrozadas, del establecimiento de Valiente. Muy al fondo se puede ver la silueta de la Catedral, en el patio del Obispo, y a su lado la zona donde hoy está la estatua dedicada a Silos Moreno.'
   },
   {
      titulo: 'Foto',
      body: 'La tienda Al Metro se salvó de la quema y también de grandes destrozos del interior, limitándose los daños a los escaparates de este establecimiento dedicado al género textil.'
   },
   {
      titulo: 'Foto',
      body: 'Los arcos interiores fueron lo poco que quedó en pie de la tienda de La Innovación, en la plaza de las Flores, una de las primeras en ser saqueadas tras el golpe militar. Pertenecía al grupo de La Riojana.'
   },
   {
      titulo: 'Foto',
      body: 'Ya en 1936 Merchán era una de las grandes tiendas de moda de la ciudad. Su promotor, procedente de Extremadura, cuidó siempre el producto y su presentación. La tienda fue quemada y sobre sus cenizas se levantó un nuevo edificio.'
   },
   {
      titulo: 'Foto',
      body: 'La imagen de la azotea del edificio de El Siglo Gaditano, en la calle Columela, deja ver el esqueleto del edificio, quemado como otros de esta céntrica vía.'
   },
   {
      titulo: 'Foto',
      body: 'El Siglo Gaditano, nada que ver con El Siglo que aún hoy sigue abierto en la calle Ancha, era otro de esos establecimientos de Cádiz de grandes dimensiones. Su amplitud es claramente visible en esta imagen de todo el inmueble.'
   },
   {
      titulo: 'Foto',
      body: 'La calle Eduardo Dato, sufrió importantes datos. La imagen muestra un inmueble calcinado, donde hoy hay una tienda del grupo Inditex. En el lateral izquierdo puede verse parte del edificio del viejo Cine Municipal y de los antiguos SMAE.'
   },
   {
      titulo: 'Foto',
      body: 'El fuego del 18 de julio ha provocado la desaparición de un edificio en la calle Columela. Aunque en semanas más tarde la ciudad será atacada por la marina y la aviación republicano, los mayores daños en las infraestructuras se produjeron en las primeras horas después del levantamiento militar.'
   },
   {
      titulo: 'Foto',
      body: 'La calle Eduardo Dato, la actual Novena, cerró el recorrido destructivo en la jornada del 18 de julio. Edificios destruidos o seriamente dañados, como la residencia de los Blázquez, de la que sólo quedó el ala principal.'
   },
   {
      titulo: 'Foto',
      body: 'Junto a edificios y comercios, numerosos templos también sufrieron el saqueo y el robo de imágenes y mobiliario. Además del Carmen, en la imagen, se vieron afectadas San Francisco, Santo Domingo, la Merced, Santiago...'
   },
   {
      titulo: 'Foto',
      body: 'El archivo de la Biblioteca Nacional cuenta con un amplio número de fotografías de los daños producidos en el Carmen, como la que se realiza de la zona del coro.'
   },
   {
      titulo: 'Foto',
      body: 'El ataque en las iglesias no se limitó a las zonas de cultos. Otras dependencias, como las oficinas y las salas de reuniones en este caso de la Merced, también sufrieron el saqueo y los destrozos.'
   },
   {
      titulo: 'Foto',
      body: 'Interior del Carmen, donde se ven con claridad los destrozos producidos. La  BNE incluye también fotografías de imágenes de diversos templos para denunciar su robo o destrucción.'
   }
]


// WEBPACK FOOTER //
// ./src/data/data.js